import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import { Header, Navigation } from './shared'
import { Home, Reservation, StorageTips } from './views'

function App() {
  const seoUrl = `community-locker-self-storage`
  const routes = [
    {name: 'Home', route: `/${seoUrl}/home`},
    {name: 'Reservation', route: `/${seoUrl}/reservation`},
    {name: 'Storage Tips', route: `/${seoUrl}/storage_tips`}
  ]

  return (
    <BrowserRouter>
      <Header text='Community Locker Self Storage' />
      <Navigation tabs={routes} />
      <Switch>
        <Route exact path={`/${seoUrl}/home`} component={Home} />
        <Route exact path={`/${seoUrl}/reservation`} component={Reservation} />
        <Route exact path={`/${seoUrl}/storage_tips`} component={StorageTips} />
        <Redirect to={`/${seoUrl}/home`} />
      </Switch>
    </BrowserRouter>
  )
}

export default App;
